<template>
    <div>
        <h1 class="h3 mb-3 text-gray-800">{{ $t("Gestão de Unidades") }}</h1>

        <b-card class="shadow">
            <div class="list-unidades-component">
                <div class="row">
                    <div class="col-12">
                        <div
                            class="d-flex align-items-center justify-content-between mb-4"
                        >
                            <router-link
                                class="btn btn-primary"
                                to="/dashboard/unidades/add"
                            >
                                <i class="fas fa-plus-square" />
                                {{ $t("Cadastrar") }}
                            </router-link>

                            <div>
                                <b-button-group>
                                    <b-button
                                        variant="outline-dark"
                                        :class="
                                            unidadesExternas === true
                                                ? 'active'
                                                : ''
                                        "
                                        @click="showExternas"
                                    >
                                        <span v-if="unidadesExternas">
                                            Todas as Unidades
                                        </span>
                                        <span v-else> Unidades Externas </span>
                                    </b-button>
                                    <b-button
                                        variant="outline-dark"
                                        :class="
                                            viewFilterReport === true
                                                ? 'active'
                                                : ''
                                        "
                                        @click="viewFilters"
                                    >
                                        <i class="fas fa-filter"></i>
                                        {{ $t("Filtros") }}
                                    </b-button>
                                    <b-button
                                        variant="outline-dark"
                                        @click="print()"
                                    >
                                        <i class="fas fa-print"></i>
                                    </b-button>
                                </b-button-group>
                            </div>
                        </div>
                    </div>

                    <div class="col-12" v-if="viewFilterReport">
                        <form @submit.prevent="getUnidades" ref="formFiltros">
                            <div class="row">
                                <form-select
                                    v-model="filtroTipos"
                                    label="Filtrar por Tipo de Unidade"
                                    grid="6"
                                    :itens="tipos"
                                    :disabled="loadingSearchTipos"
                                    :loading="loadingSearchTipos"
                                    :multiple="true"
                                />

                                <form-select
                                    v-model="filtroStatus"
                                    grid="6"
                                    label="Status"
                                    :itens="status"
                                    :loading="loadingStatus"
                                    :disabled="loadingStatus"
                                    :multiple="true"
                                />

                                <div class="col-md-12">
                                    <label><b>Pesquisar</b></label>
                                    <div class="input-group">
                                        <b-input
                                            placeholder="Nome da Unidade, e-mail ou telefone"
                                            class="form-control search-input"
                                            type="text"
                                            v-model="search"
                                            aria-describedby="input-search"
                                            @keydown.enter.prevent="getUnidades"
                                        />
                                        <div
                                            class="input-group-append"
                                            role="button"
                                            @click.prevent="getUnidades"
                                        >
                                            <span
                                                class="input-group-text"
                                                id="input-search"
                                                ><i
                                                    class="fas fa-search search-icon"
                                            /></span>
                                        </div>
                                    </div>
                                    <p class="small text-muted">
                                        Através do campo acima você pode
                                        pesquisar por: Nome da Unidade, e-mail
                                        ou telefone
                                    </p>
                                </div>
                            </div>
                            <div
                                class="row pt-2 mb-4 px-0 d-flex justify-content-end"
                            >
                                <div class="col-auto px-2 text-right">
                                    <button
                                        class="btn btn-default btn-sm"
                                        @click.prevent="
                                            limparFiltros();
                                            viewFilterReport = false;
                                        "
                                    >
                                        <i class="fas fa-times"></i>
                                    </button>

                                    <button
                                        type="button"
                                        class="btn btn-secondary btn-sm"
                                        @click.prevent="limparFiltros()"
                                    >
                                        {{ $t("Limpar Filtros") }}
                                    </button>
                                    <button
                                        class="btn btn-success btn-submit btn-sm"
                                        data-style="zoom-in"
                                        type="submit"
                                    >
                                        <i class="fas fa-chart-bar"></i>
                                        {{ $t("Filtrar") }}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div class="col-12">
                        <loading-animation
                            :active.sync="loading"
                            :is-full-page="false"
                            :opacity="1"
                            color="#5895FF"
                        />
                        <print-content>
                            <b-table
                                :fields="[
                                    {
                                        key: 'nome_tipo_unidade',
                                        label: $t('Tipo'),
                                    },
                                    {
                                        key: 'nome',
                                        label: $t('Nome'),
                                    },
                                    {
                                        key: 'status',
                                        label: $t('Status'),
                                    },
                                    {
                                        key: 'actions',
                                        label: '',
                                        class: 'text-right no-print',
                                        thStyle: {
                                            width: '95px',
                                            minWidth: '95px',
                                        },
                                    },
                                ]"
                                :items="unidadesList"
                                :responsive="true"
                                striped
                                hover
                                show-empty
                                small
                                outlined
                                stacked="xs"
                                table-class="mb-3"
                            >
                                <template v-slot:cell(nome_tipo_unidade)="data">
                                    {{ data.item.nome_tipo_unidade }}
                                </template>
                                <template v-slot:cell(nome)="data">
                                    <strong
                                        class="d-block"
                                        v-if="data.item"
                                        v-html="
                                            $options.filters.highlight(
                                                data.item.nome,
                                                search
                                            )
                                        "
                                    ></strong>

                                    <span
                                        class="mt-1 d-block"
                                        v-if="data.item.email"
                                        v-html="
                                            $options.filters.highlight(
                                                data.item.email,
                                                search
                                            )
                                        "
                                    ></span>

                                    <span
                                        class="mt-1 d-block"
                                        v-if="data.item.telefone"
                                        v-html="
                                            $options.filters.highlight(
                                                data.item.telefone,
                                                search
                                            )
                                        "
                                    ></span>

                                    <span
                                        class="mt-1 d-block"
                                        v-if="data.item.tecnicos.length > 0"
                                    >
                                        Equipe SUAS:
                                        <strong
                                            >({{
                                                data.item.tecnicos.length
                                            }})</strong
                                        >
                                    </span>
                                </template>

                                <template v-slot:cell(status)="data">
                                    <span v-html="data.item.status_nome"></span>
                                </template>

                                <template v-slot:cell()="data">
                                    <b-button
                                        :title="$t('Editar Unidade')"
                                        :to="
                                            '/dashboard/unidades/edit/' +
                                            data.item.id
                                        "
                                        class="px-2 mb-0"
                                        size="xs"
                                        type="button"
                                        v-b-tooltip.hover
                                        variant="success"
                                    >
                                        <i
                                            class="mdi mdi-square-edit-outline"
                                        />
                                    </b-button>
                                </template>
                                <template v-slot:empty="scope">
                                    <div class="text-center my-5">
                                        <img
                                            :alt="$t('No results')"
                                            class="mb-5"
                                            src="/img/icons/robot.svg"
                                            style="max-height: 165px"
                                        />
                                        <h3 class="bold">
                                            {{ $t("No records found") }}
                                        </h3>
                                    </div>
                                </template>
                            </b-table>
                        </print-content>
                        <div class="row align-items-center no-print">
                            <div class="col-lg-6 col-md-12">
                                <div class="form-group d-inline-flex mb-0">
                                    <select
                                        class="form-control"
                                        style="width: 70px"
                                        v-model="perPage"
                                        v-on:change="getUnidades"
                                    >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                    </select>
                                </div>
                                <div class="d-inline-flex ml-2">
                                    <b-pagination
                                        :per-page="perPage"
                                        :total-rows="pagination.total"
                                        @change="changePage"
                                        v-model="page"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                                <div class="float-lg-right">
                                    {{ $t("Showing page") }}
                                    {{ pagination.currentPage }}
                                    {{ $t("of") }}
                                    {{ pagination.totalPages }}
                                    {{ $t("pages in") }}
                                    {{ pagination.total }}
                                    {{ $t("records") }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <router-view />
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "Unidades",
    metaInfo() {
        return {
            title: this.$i18n.t("Gestão de Unidades"),
        };
    },
    data() {
        return {
            page: 1,
            search: "",
            perPage: 10,
            loading: true,
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0,
            },
            unidadesList: [],
            filtroStatus: null,
            filtroTipos: null,
            tipos: [],
            status: [],
            loadingStatus: false,
            loadingSearchTipos: true,
            unidadesExternas: false,
        };
    },
    mounted() {
        this.getStatus();
        this.getTipos();
        this.getUnidades();
    },
    methods: {
        showExternas() {
            this.unidadesExternas = !this.unidadesExternas;
            this.getUnidades();
        },
        changePage(page) {
            if (
                page > 0 &&
                page <= this.pagination.totalPages &&
                page !== this.page
            ) {
                this.page = page;
                this.getUnidades();
            }
        },
        getUnidades() {
            this.loading = true;
            axios
                .get("api/dashboard/unidades", {
                    params: {
                        page: this.page,
                        search: this.search,
                        perPage: this.perPage,
                        filtroStatus: this.filtroStatus,
                        filtroTipos: this.filtroTipos,
                        unidadesExternas: this.unidadesExternas
                            ? this.unidadesExternas
                            : null,
                    },
                })
                .then((response) => {
                    this.unidadesList = response.data.data;
                    this.pagination = response.data.pagination;
                    if (
                        this.pagination.totalPages < this.pagination.currentPage
                    ) {
                        this.page = this.pagination.totalPages;
                        this.getUnidades();
                    } else {
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getTipos() {
            this.loadingSearchTipos = true;
            axios
                .get(`api/dashboard/unidade/tipos`)
                .then((response) => {
                    this.tipos = response.data;
                })
                .finally(() => (this.loadingSearchTipos = false));
        },
        getStatus() {
            this.loadingStatus = true;
            axios
                .get(`api/dashboard/status/unidades`)
                .then((response) => {
                    this.status = response.data;
                })
                .finally(() => {
                    this.loadingStatus = false;
                });
        },
        limparFiltros() {
            this.search = "";
            this.filtroStatus = null;
            this.filtroTipos = null;
            this.getUnidades();
        },
    },
};
</script>
